import * as t from "io-ts";

export const DynamicFieldReturnTypeV = t.union([
  t.literal("all"),
  t.literal("string"),
  t.literal("image_url"),
  t.literal("gallery"),
  t.literal("video"),
  t.literal("url"),
  t.literal("query"),
  t.literal("google_map"),
  t.literal("repeater"),
  t.literal("flexible_content")
]);

export type DynamicFieldReturnType = t.TypeOf<typeof DynamicFieldReturnTypeV>;

export const DynamicPropertyPathV = t.intersection([
  t.type({
    path: t.string,
    accepts: DynamicFieldReturnTypeV
  }),
  t.partial({
    proOnly: t.union([t.undefined, t.boolean])
  })
]);

export type DynamicPropertyPath = t.TypeOf<typeof DynamicPropertyPathV>;
